export default "__VITE_ASSET__DTSc2eYQ__"